import styled, { keyframes } from 'styled-components';

const LoadingBarContainer = styled.div`
  width: 100%;
  height: 4px;
  background-color: #f0f0f0;
  position: relative;
  overflow: hidden;
  border-radius: 2px;
`;

function LoadingBar() {
  const dynamicProgress = keyframes`
    0% {
      width: 0%;
      left: 0%;
    }
    50% {
      width: 100%;
      left: 0%;
    }
    100% {
      width: 0%;
      left: 100%;
    }
  `;

  const DynamicBar = styled.div`
    position: absolute;
    height: 100%;
    background: var(--color-medium-purple);
    animation: ${dynamicProgress} 1.5s ease-in-out infinite;
    border-radius: 4px;
  `;

  return (
    <LoadingBarContainer>
      <DynamicBar />
    </LoadingBarContainer>
  );
}

export default LoadingBar;
